import type { DealFormData } from '@openx/types/deal.ts';
import { useEffect, useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ThirdPartyFeeInfo } from '../../../../components/DealRevenueCalculator/DealRevenueModifiersContext/components/ThirdPartyFeeInfo.tsx';
import { useHasDealRevenueCalculatorAccess } from '../../../../components/DealRevenueCalculator/hooks/useHasDealRevenueCalculatorAccess.ts';
import { useDealFormContext } from '../../../DealForm.context.tsx';
import { ThirdPartyFeeConfig } from './ThirdPartyFeeConfig.tsx';

type ThirdPartyFeeConfigsProps = {
  isFilledOut: boolean;
};

export const ThirdPartyFeeConfigs = ({ isFilledOut }: ThirdPartyFeeConfigsProps) => {
  const { thirdPartyPartnerOptions, thirdPartyPartnerOptionsLoading } = useDealFormContext();
  const hasDealRevenueCalculatorAccess = useHasDealRevenueCalculatorAccess();
  const { fields } = useFieldArray<DealFormData, 'third_party_fees_config'>({ name: 'third_party_fees_config' });
  const { setValue } = useFormContext<DealFormData>();

  const partnerIdList = useMemo(() => Object.keys(thirdPartyPartnerOptions), [thirdPartyPartnerOptions]);

  useEffect(() => {
    // autofill the partner if there is only one
    if (partnerIdList.length === 1) {
      setValue('third_party_fees_config.0.partner_id', partnerIdList.at(0)!, { shouldValidate: true });
    }
  }, [partnerIdList, setValue]);

  return (
    <>
      {fields.map((field, index) => (
        <ThirdPartyFeeConfig
          index={index}
          isFilledOut={isFilledOut}
          isLoading={thirdPartyPartnerOptionsLoading}
          key={field.id}
          partnerById={thirdPartyPartnerOptions}
          partnerIdList={partnerIdList}
        />
      ))}

      {hasDealRevenueCalculatorAccess && <ThirdPartyFeeInfo />}
    </>
  );
};
